import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { AboutUsHero } from './components/Hero'
import { AboutUsMission } from './components/Mission'
import { AboutUsInvestors } from './components/Investors'
import classes from './AboutUs.module.scss'

export default function AboutUsPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'About Us'} />
      <Container grid>
        <AboutUsHero />
        <AboutUsMission />
        <AboutUsInvestors />
      </Container>
    </DefaultPageLayout>
  )
}
